import React, { useCallback, useEffect } from "react";

import FooterDescription from "../../components/ui/FooterDescription";
import FooterLogo from "../../components/ui/FooterLogo";
import ProfessionAttachements from "../../components/Profession/ProfessionAttachements";
import ProfessionCell from "../../components/Profession/ProfessionCell";
import ProfessionDate from "../../components/Profession/ProfessionDate";
import ProfessionTitle from "../../components/Profession/ProfessionTitle";
import Props from "./props";
import SingleProfessionCategories from "../../components/Profession/SingleProfessionCategories";
import TablePaper from "../../components/ui/TablePaper/styled";
import ToggleProfessionEditing from "../../components/Profession/ToggleProfessionEditing";
import resetToggleProfessionEditingAction from "./../../../state/actions/ProfessionActions/resetToggleProfessionEditingAction";
import sendEditProfessionAction from "../../../state/actions/ProfessionActions/sendEditProfessionAction";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import useProfession from "../../../state/hooks/ProfessionHooks/useProfession";
import useProfessionsAndCategories from "./../../../state/hooks/ProfessionHooks/useProfessionsAndCategories";

interface Field {
    field: string;
    label: string;
}

const Single: React.FC<Props> = (props) => {
    useProfession();
    useProfessionsAndCategories();
    const dispatch = useDispatch();
    const resetToggleProfessionEditing = useCallback(() => dispatch(resetToggleProfessionEditingAction()), [dispatch]);
    useEffect(() => {
        return () => {
            resetToggleProfessionEditing();
        };
    }, [resetToggleProfessionEditing]);
    const sendEditProfession = useCallback(() => dispatch(sendEditProfessionAction()), [dispatch]);
    const fields: Field[] = [
        {
            field: "what_it_does",
            label: "Cosa fa",
        },
        {
            field: "who_is",
            label: "Chi è",
        },
        {
            field: "how_to_become",
            label: "Come diventare",
        },
        {
            field: "how_much_earns",
            label: "Quanto guadagna",
        },
        {
            field: "where_to_go",
            label: "A chi rivolgersi",
        },
    ];
    return (
        <Wrapper
            onSubmit={(e: React.FormEvent) => {
                e.preventDefault();
                sendEditProfession();
            }}
        >
            <ToggleProfessionEditing />
            <TablePaper>
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <div className="page">
                                    <ProfessionTitle />
                                    {fields.length && fields.map(({ field, label }) => <ProfessionCell key={field} field={field} label={label} />)}
                                    <SingleProfessionCategories />
                                    <ProfessionAttachements />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>
                                <div className="page-footer-space"></div>
                            </td>
                        </tr>
                    </tfoot>
                </table>
                <FooterLogo />
                <ProfessionDate />
                <FooterDescription />
            </TablePaper>
        </Wrapper>
    );
};

export default Single;

const Wrapper = styled.form`
    width: 60rem;
    margin: 0 auto;
    padding: 5rem 0;
    @media print {
        padding: 0;
        max-width: 100%;
    }
    table {
        width: 100%;
    }
    .page-footer,
    .page-footer-space {
        height: 8rem;
    }
    .page-footer {
        position: fixed;
        bottom: 0;
    }
    .page {
        /* page-break-after: always; */
    }
`;
